import { render } from "./EditSales.vue?vue&type=template&id=ffcd7a48"
import script from "./EditSales.vue?vue&type=script&lang=js"
export * from "./EditSales.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script